import { render, staticRenderFns } from "./jsaList.vue?vue&type=template&id=8430944c"
import script from "./jsaList.vue?vue&type=script&lang=js"
export * from "./jsaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8430944c')) {
      api.createRecord('8430944c', component.options)
    } else {
      api.reload('8430944c', component.options)
    }
    module.hot.accept("./jsaList.vue?vue&type=template&id=8430944c", function () {
      api.rerender('8430944c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/jsaList.vue"
export default component.exports